import { createSlice } from "@reduxjs/toolkit";

// Define initial state for whiskies
const initialState = {
  whiskies: [], // Holds the list of whiskies
  distilleries: [], // Holds the list of distilleries
  loading: false, // Tracks loading state
  error: null, // Error handling
  filteredWhiskies: [], // Holds the filtered list of whiskies (for search or filter)
};

const whiskiesSlice = createSlice({
  name: "whiskies", // Slice name
  initialState, // Initial state
  reducers: {
    // Reducer to handle setting the whiskies
    setWhiskies: (state, action) => {
      state.whiskies = action.payload; // Action will pass the list of whiskies
    },

    // Reducer to handle setting distilleries
    setDistilleries: (state, action) => {
      state.distilleries = action.payload;
    },

    // Reducer to handle loading state
    setLoading: (state, action) => {
      state.loading = action.payload; // Action will pass the loading status
    },

    // Reducer to handle errors
    setError: (state, action) => {
      state.error = action.payload; // Action will pass an error message
    },

    // Reducer to set filtered whiskies
    setFilteredWhiskies: (state, action) => {
      state.filteredWhiskies = action.payload;
    },
  },
});

// Export actions (these will be automatically dispatched in your components)
export const {
  setWhiskies,
  setDistilleries,
  setLoading,
  setError,
  setFilteredWhiskies,
} = whiskiesSlice.actions;
// Export the reducer (this will be used in your store)
export default whiskiesSlice.reducer;
